import { Card } from "@/components/ui/card";
import {
  Trophy,
  Star,
  Heart,
  Crown,
  Flame,
  UserPlus,
  CheckCircle,
  Medal,
  Zap,
  Target,
  Repeat,
  Moon,
  Sunrise,
  CalendarDays,
  Users,
  Award,
  TrendingUp,
  type LucideIcon,
} from "lucide-react";
import {
  ACHIEVEMENT_CATALOG,
  ALL_ACHIEVEMENT_TYPES as DB_ALL_ACHIEVEMENT_TYPES,
  type AchievementType,
} from "@workspace/db/achievements";
import { cn } from "@/lib/utils";

export type AchievementBadgeType = AchievementType;

export const ALL_ACHIEVEMENT_TYPES: AchievementBadgeType[] = DB_ALL_ACHIEVEMENT_TYPES;

const ICON_MAP: Record<string, LucideIcon> = {
  trophy: Trophy,
  star: Star,
  heart: Heart,
  crown: Crown,
  flame: Flame,
  "user-plus": UserPlus,
  "check-circle": CheckCircle,
  medal: Medal,
  zap: Zap,
  target: Target,
  repeat: Repeat,
  moon: Moon,
  sunrise: Sunrise,
  "calendar-days": CalendarDays,
  users: Users,
  award: Award,
  "trending-up": TrendingUp,
};

interface AchievementBadgeProps {
  type: AchievementBadgeType;
  unlocked: boolean;
  unlockedAt?: Date;
}

export function AchievementBadge({ type, unlocked, unlockedAt }: AchievementBadgeProps) {
  const achievement = ACHIEVEMENT_CATALOG[type];

  if (!achievement) {
    return (
      <Card className="p-4 text-center bg-muted text-muted-foreground opacity-50">
        <Trophy className="h-8 w-8 mx-auto mb-2" />
        <p className="font-semibold text-sm">Logro Desconocido</p>
        <p className="text-xs opacity-90">Tipo: {type}</p>
      </Card>
    );
  }

  const Icon = ICON_MAP[achievement.iconKey] ?? Trophy;

  return (
    <Card
      className={cn(
        "p-4 text-center transition-all",
        unlocked
          ? `bg-gradient-to-br ${achievement.color} text-white`
          : "bg-muted text-muted-foreground opacity-50"
      )}
      data-testid={`badge-achievement-${type}`}
    >
      <Icon className="h-8 w-8 mx-auto mb-2" />
      <p className="font-semibold text-sm">{achievement.title}</p>
      <p className="text-xs opacity-90">{achievement.description}</p>
      {unlocked && unlockedAt && (
        <p className="text-xs mt-2 opacity-75">
          {new Date(unlockedAt).toLocaleDateString("es-ES")}
        </p>
      )}
    </Card>
  );
}
